import {Box, Skeleton} from '@mui/material'
import type {FC, ReactElement} from 'react'
import BasicDashboardContainer from '@shared/components/BasicDashboardContainer'

const HEADER_SKELETON_KEYS = ['header-1', 'header-2', 'header-3', 'header-4']

const SettingsLoader: FC = (): ReactElement => (
  <BasicDashboardContainer>
    <Box
      data-testid="mbai-main-settings-page-loader"
      sx={{
        width: '100%',
        height: '100vh',
      }}
    >
      <Box
        sx={{
          pt: 2,
          display: 'flex',
        }}
      >
        {HEADER_SKELETON_KEYS.map((key) => (
          <Skeleton
            key={key}
            variant="rounded"
            sx={{
              width: '200px',
              height: '24px',
              mx: 1,
            }}
          />
        ))}
      </Box>
      <Box
        sx={{
          pt: 3,
          height: 'calc(100vh - 165px)',
          display: 'flex',
        }}
      >
        <Skeleton
          variant="rounded"
          sx={{
            width: '100%',
            height: '100%',
          }}
        />
        <Skeleton
          variant="rounded"
          sx={{
            width: 'calc(100% - 24px)',
            height: '100%',
            ml: 2,
          }}
        />
      </Box>
    </Box>
  </BasicDashboardContainer>
)

export default SettingsLoader
